import { Star } from "lucide-react";

export function Stars({ value = 0, size = 12 }) {
    const full = Math.floor(value);
    const half = value - full >= 0.5;
    return (
        <span className="inline-flex items-center gap-0.5">
            {[0, 1, 2, 3, 4].map((i) => (
                <Star
                    key={i}
                    size={size}
                    strokeWidth={1.5}
                    className={
                        i < full || (i === full && half)
                            ? "fill-veda-warning text-veda-warning"
                            : "text-veda-borderStrong"
                    }
                />
            ))}
        </span>
    );
}

export function StatusBadge({ status }) {
    const map = {
        approved: "border-veda-success/40 bg-veda-success/10 text-veda-success",
        pending: "border-veda-warning/40 bg-veda-warning/10 text-veda-warning",
        rejected: "border-veda-error/40 bg-veda-error/10 text-veda-error",
    };
    return (
        <span
            className={`rounded-pill border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.14em] ${
                map[status] || "border-veda-border text-veda-muted"
            }`}
        >
            {status}
        </span>
    );
}

export function VerifiedBadge({ testid }) {
    return (
        <span
            data-testid={testid}
            className="rounded-pill border border-veda-brand/40 bg-veda-brand/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.14em] text-veda-brand"
        >
            Verified
        </span>
    );
}

export function Chip({ children, active, onClick, testid }) {
    return (
        <button
            data-testid={testid}
            onClick={onClick}
            className={`h-9 shrink-0 rounded-pill border px-4 text-xs font-semibold uppercase tracking-[0.14em] transition-colors ${
                active
                    ? "border-veda-inverse bg-veda-inverse text-veda-onInverse"
                    : "border-veda-border bg-veda-surface text-veda-onSurface hover:bg-veda-surface2"
            }`}
        >
            {children}
        </button>
    );
}

export function Money({ value }) {
    return (
        <span className="tabular-nums">
            ₹{Number(value || 0).toLocaleString("en-IN")}
        </span>
    );
}

// Renders a shared "loading | empty | content" flow so pages avoid deep nested ternaries.
export function ListShell({ loading, isEmpty, emptyMessage, children }) {
    if (loading) {
        return (
            <p className="py-6 text-center text-sm text-veda-muted">Loading...</p>
        );
    }
    if (isEmpty) {
        return (
            <p className="py-6 text-center text-sm text-veda-muted">
                {emptyMessage}
            </p>
        );
    }
    return children;
}
